/**
 * RUXMediaScope - pure scope-matching rules for PDP variant media.
 * No DOM access. Mirrored by the Liquid implementation in
 * snippets/product-media-column.liquid; keep the two in step.
 */
(function (global) {
  'use strict';

  function parseScope(scopeAttr) {
    var scope = {};
    if (!scopeAttr) return scope;
    var parts = scopeAttr.trim().split(/\s+/);
    for (var i = 0; i < parts.length; i++) {
      var idx = parts[i].indexOf(':');
      if (idx < 1) continue;
      scope[parts[i].slice(0, idx)] = parts[i].slice(idx + 1);
    }
    return scope;
  }

  // Dimension names in the order they appear. Object key order cannot be
  // trusted for this: a numeric-looking handle would sort ahead of the rest.
  function parseScopeOrder(scopeAttr) {
    var dims = [];
    if (!scopeAttr) return dims;
    var parts = scopeAttr.trim().split(/\s+/);
    for (var i = 0; i < parts.length; i++) {
      var idx = parts[i].indexOf(':');
      if (idx < 1) continue;
      var dim = parts[i].slice(0, idx);
      if (dims.indexOf(dim) === -1) dims.push(dim);
    }
    return dims;
  }

  function matchesScope(scopeAttr, selection, ignoredDimensions) {
    var scope = parseScope(scopeAttr);
    var ignored = ignoredDimensions || [];
    for (var dim in scope) {
      if (!Object.prototype.hasOwnProperty.call(scope, dim)) continue;
      if (ignored.indexOf(dim) !== -1) continue;
      if (selection[dim] !== scope[dim]) return false;
    }
    return true;
  }

  // dimensions: most-significant first. Drops the least significant first,
  // then falls back to everything. Never returns an empty list.
  //
  // There is NO universal-only rung between the two, and there must not be one.
  // A universal item has an empty scope, so it declares no dimension, nothing
  // is enforced against it, and it matches VACUOUSLY on the first rung.
  // "Nothing matched above" therefore proves there were no universal items to
  // fall back to, and a universal-only rung could never fire. Design 6 strikes
  // it out for exactly this reason - do not re-add it, and do not "fix" rung 1
  // into requiring at least one matching pair to make it reachable.
  //
  // snippets/product-media-column.liquid mirrors this chain step for step and
  // likewise has no universal-only rung; keep the two in step.
  function resolveVisible(items, selection, dimensions) {
    for (var drop = 0; drop < dimensions.length; drop++) {
      var ignored = dimensions.slice(dimensions.length - drop);
      var visible = items.filter(function (item) {
        return matchesScope(item.scope, selection, ignored);
      });
      if (visible.length) {
        return { visible: visible, ignoredDimensions: ignored };
      }
    }

    return { visible: items.slice(), ignoredDimensions: dimensions.slice() };
  }

  global.RUXMediaScope = {
    parseScope: parseScope,
    parseScopeOrder: parseScopeOrder,
    matchesScope: matchesScope,
    resolveVisible: resolveVisible,
  };
})(typeof window !== 'undefined' ? window : globalThis);
